module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-14-ada3967c5543e1ecc729c67b44691d3c.webp";